import {
    getZoneIdLoading,
    getZoneIdRequest,
    getZoneIdSuccess,
    getZoneIdReject,
} from "../../actions/zone/getId";

export const getZoneId = (formData) => async (dispatch, getState) => {
    dispatch(getZoneIdLoading());
    try {
        const { data } = await getZoneIdRequest(formData, getState);
        dispatch(getZoneIdSuccess(data))
    } catch (error) {
        dispatch(getZoneIdReject(error))
    }
    return Promise.resolve();
};